import { createContext, useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import Swal from 'sweetalert2';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../config/firebase';
import { userActive } from '../assets/js/functions';

export const SidebarContext = createContext({});

export const SidebarProvider = ({ children }) => {
	const [isSidebarOpen, setSidebarOpen] = useState(false);

	useEffect(() => {
		if (!window.location.pathname.startsWith('/admin')) return;
		const unsub = onAuthStateChanged(auth, async (user) => {
			if (!user) return;
			const data = await userActive();
			if (!data) return;
			if (window.location.pathname !== '/admin/configuracion' && data.cambiarContraseña) {
				Swal.fire({
					title: '¡Espera!',
					html: 'Tienes una contraseña temporal, por favor cámbiala por una más segura.',
					icon: 'warning',
					confirmButtonText: 'Cambiar',
					confirmButtonColor: '#c1212a',
				}).then((result) => {
					if (result.isConfirmed) window.location.replace('/admin/configuracion');
				});
			}
		});
		return () => unsub();
	}, []);

	return (
		<SidebarContext.Provider value={{ isSidebarOpen, openSidebar: () => setSidebarOpen(true), closeSidebar: () => setSidebarOpen(false) }}>
			{children}
		</SidebarContext.Provider>
	);
};

SidebarProvider.propTypes = { children: PropTypes.node };
